import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { BreadcrumbItemContext } from '../../provider/BreadcrumbItemContextProvider';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MetadataContentTabs } from '../../ui-parts/MetadataContentTabs';
import { useLocation } from 'react-router-dom';
import { MyMModal } from '../../ui-elements/MyMModal';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';

/** MyMine Version2.0 TrainingLv2SubLv1画面新規追加
* TrainingLv2SubLv1 Page Content
*/
export const TrainingLv2SubLv1 = () => {
  const screenId = 'MyM318';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState(null);
  const queryParam = useParams();
  const navigate = useNavigate();
  const { setBreadcrumbItem } = useContext(BreadcrumbItemContext);
  // 2025.3.5 MyMine Version2.1対応 Add Start
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  // 2025.3.5 MyMine Version2.1対応 Add End

  useEffect(() => {

    /**
     * Contents情報取得成功時処理
     * @param {any} result
     */
    const callbackSuccessRequestTraingContents = (result) => {

      if (result === null) {
        // 取得情報がない場合、失敗処理を行う
        callbackFailedRequestTrainingContents();
        return;
      }

      // パンくずリストにMetadataNameを設定
      setBreadcrumbItem(result.ModelMetadataName);
      setContent(result);
      setIsLoading(false);

      // 2025.3.5 MyMine Version2.1対応 Add Start
      if (location.state?.previewFileId) {
        setPreviewFileId(location.state.previewFileId);
        setIsModalOpen(true);
      }
      // 2025.3.5 MyMine Version2.1対応 Add End
    }

    /**
     * Contents情報取得失敗時処理
     */
    const callbackFailedRequestTrainingContents = () => {
      setIsLoading(false);
      // エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }

    // 表示情報取得
    apiRequest.requestJson(`api/training/lv2-1`, 'GET', callbackSuccessRequestTraingContents, callbackFailedRequestTrainingContents)

    // アンマウント時、パンくずリストのコンテキストをクリア
    return () => {
      setBreadcrumbItem(null);
    }

  }, []);

  if (content == null)
    return <MyMProgress />

  return (
    <Box className='py-1 d-flex flex-column'>
      {isLoading && <MyMProgress />}
      <Box className='mb-4'>
        <MyMVariantLabel variant='h5'>{content.ModelMetadataName}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblTrainingLevel2_1Massage}</MyMLabel>
      </Box>
      <Grid container className='pb-2 flex-grow-1'>
        <Grid item xs={12} md={3} className='d-flex justify-content-center' sx={{ '> img': { maxWidth: '100%', maxHeight: 300 } }}>
          {controlSettings.ImageList.imgTrainingLevel2_1 && <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgTrainingLevel2_1} />}
        </Grid>
        <Grid item xs={12} md={8.7}>
          <MetadataContentTabs
            paramMetadataId={queryParam.metadata_id}
            screenId={screenId}
            metadataContent={content}
            setIsLoading={setIsLoading}
            // 2025.3.5 MyMine Version2.1対応 Add Start
            canShareContents={true}
            contentsShareParameter={location.state}
            isDefaultOpenFirstAccordion={true}
            // 2025.3.5 MyMine Version2.1対応 Add End
          />
        </Grid>
      </Grid>
      {/* 2025.3.5 MyMine Version2.1対応 Add Start */}
      <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
      {/* 2025.3.5 MyMine Version2.1対応 Add End */}
    </Box>
  );
}

export default TrainingLv2SubLv1;